import cx from 'classnames';
import * as React from 'react';
import MediaObject from 'components/MediaObject';

import './styles/AdminUpgradePlanQuoteBoxRow.scss';

type Props = {
  border?: boolean;
  highlighted?: boolean;
  children: [React.ReactNode, React.ReactNode];
};

export default function AdminUpgradePlanQuoteBoxRow(props: Props) {
  const { border, highlighted, children } = props;

  return (
    <div
      className={cx(
        'AdminUpgradePlanQuoteBoxRow',
        border && `AdminUpgradePlanQuoteBoxRow--border`,
        highlighted && 'AdminUpgradePlanQuoteBoxRow--highlighted'
      )}>
      <MediaObject figure="right">{children}</MediaObject>
    </div>
  );
}
